module.exports = __webpack_public_path__ + "assets/headlight-black.c9a8e42b.svg";